/*  --------------------------------------------------------------------------------
    waitForFinalEvent();

    *   Zeitverzoegerung wenn das Browserfensters verstellt wird

    *   Beispiel:
        waitForFinalEvent( function() {
    
            hier kommt Dein Code, welcher nach der Verzoegerung ausgefuehrt wird....

        }, 500, "<cfoutput>#createUuid()#</cfoutput>");
---------------------------------------------------------------------------------- */
var waitForFinalEvent = (function () {
    "use strict"; // Preventing you from using undeclared variables. IE 9 will not throw an error even if it does not understand it.

    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout (timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();//end: ---------- * waitForFinalEvent * --------------------
